export async function hash(algorithm: AlgorithmIdentifier, text: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(text);

  return await crypto.subtle.digest(algorithm, data);
}
